import { render, staticRenderFns } from "./gui_watermark.vue?vue&type=template&id=5703b974&"
import script from "./gui_watermark.vue?vue&type=script&lang=js&"
export * from "./gui_watermark.vue?vue&type=script&lang=js&"
import style0 from "./gui_watermark.vue?vue&type=style&index=0&id=5703b974&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports